import { VehicleOption, ConditionLookupTables, MaxiTaxiLookUpType, ApiVehicleOption } from './Redux/ConditionEntities'
import appstore from '../../appStore';
import { ConvertToServiceInfo } from './VehicleToServiceTranslater';
import { Vehicle } from '../../Services/MakeBookingContracts';
import services, { ServiceInfo } from '../../utils/service-vehicles/ServiceMetadata';
import { GetMyBrand } from '../../Config/MyAppConfig';
import { Brand } from '../../Config/Entities/Brand';
import { ServiceKind } from "../../utils/service-vehicles/ServiceMetadata";

/**
 * Process raw vehicle types (Ids) from Global Booker and map them to vehicle details.
 * With initial loading of vehicles from the API, vehicleTypes parameter is null so the default list for the brand is displayed.
 */
export function MakeVehicleLookupFromApiData(vehicleTypes: number[] | null): ConditionLookupTables {
    const ConditionList: VehicleOption[] = [];
    const MaxiTaxiLookUp: MaxiTaxiLookUpType = {};

    const allVehicles = appstore.getState().condition.AllVehicles;

    let vehiclesToDisplay: Vehicle[] = [];

    if (!vehicleTypes) {
        vehiclesToDisplay = allVehicles.filter(i => i.IsInDefaultList);
    } else {
        for (let vehicle of allVehicles) {
            if (vehicleTypes.some(i => i == vehicle.GlobalBookerVehicleId)) {
                vehiclesToDisplay.push(vehicle);
            }
        }
    }

    for (var vehicle of vehiclesToDisplay) {

        // Condition is dummy here, and useless for GB implementation, maybe this implementation is not ideal?
        const vehicleOption: ApiVehicleOption = {
            ApiVersion: 2,
            ApiId: vehicle.GlobalBookerVehicleId,
            Name: vehicle.Name,
            MaxSeat: 0,
            Description: vehicle.ShortDescription
        };

        const service = ConvertToServiceInfo(vehicle);

        ConditionList.push({ Service: service, ApiVehicle: vehicleOption });        
    }

    // Add "Next Available" option (matching V1 behavior)
    // Determine which "any" to use based on presence of limo vehicles
    const hasLimo = vehiclesToDisplay.some(v => /limo/i.test(v.Name));
    const nextAvailable = hasLimo ? services.anySA : services.any;
    
    // Add NextAvailable to the beginning of the list (unless SilverService brand)
    const brand = GetMyBrand();
    if (brand !== Brand.SilverService) {
        ConditionList.unshift(MakeVehicleFromService(nextAvailable));
    }

    return { ConditionList: ConditionList, MaxiTaxiLookUp: MaxiTaxiLookUp };
};

/**
 * Helper function to create a VehicleOption from a ServiceInfo
 * Maps "Next Available" to appropriate TaxiServiceId based on region
 */
function MakeVehicleFromService(service: ServiceInfo): VehicleOption {
    // Determine TaxiServiceId based on region:
    // - NextAvailableSouthAustralia → TaxiServiceId 7 (SedanNot13Limo)
    // - NextAvailable → TaxiServiceId 1 (NextAvailable)
    const isSouthAustralia = service.kind === ServiceKind.NextAvailableSouthAustralia;
    
    const taxiServiceId = isSouthAustralia ? 7 : 1;
    const vehicleName = isSouthAustralia ? "SedanNot13Limo" : "NextAvailable";
    
    const apiVehicle: ApiVehicleOption = {
        ApiVersion: 2,
        ApiId: taxiServiceId,
        Name: vehicleName,
        MaxSeat: 4,
        Description: `Next Available`
    };
    
    return { Service: service, ApiVehicle: apiVehicle };
}
